// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__7nl8b","title":"Header_title__YBec-","side":"Header_side__8VA9c"};